import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import logo from '../../assets/logo.png'; // ✅ Add your logo in /src/assets/logo.png

interface HeaderProps {
  onToggleSidebar: () => void;
  isSidebarOpen: boolean;
}

const Header: React.FC<HeaderProps> = ({ onToggleSidebar, isSidebarOpen }) => {
  const { user } = useAuth();

  return (
    <header className="bg-white border-b border-gray-200 shadow-sm">
      <div className="flex items-center justify-between px-4 py-3 sm:px-6">
        {/* Left side - Logo + Toggle */}
        <div className="flex items-center space-x-3">
          {/* Logo */}
          <img
            src={logo}
            alt="Vending Cards Logo"
            className="h-11 w-auto object-contain"
          />
          {/* <h1 className="text-xl font-semibold text-gray-900 hidden sm:block">
            Vending Cards
          </h1> */}
          {/* Sidebar Toggle */}
          <button
            onClick={onToggleSidebar}
            className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500 transition-colors"
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isSidebarOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>

         
        </div>

        {/* Right side - User info */}
        <div className="flex items-center space-x-3">
          <div className="hidden sm:block text-right">
            <p className="text-sm font-medium text-gray-900">{user?.name}</p>
            <p className="text-xs text-gray-500">Customer Account</p>
          </div>

          <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center shadow">
            <span className="text-white text-sm font-medium">
              {user?.name?.split(' ').map(n => n[0]).join('').toUpperCase()}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
